// extracted by mini-css-extract-plugin
export default {"asideCefX":"styles_asideCefX__3KA10","tiposDePontos":"styles_tiposDePontos__VL63E","wrapper_tiposDePontos":"styles_wrapper_tiposDePontos__BcWvU","point":"styles_point__uUkaz"};